// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.instrument-row {
  font-size: 14px;
  vertical-align: top;
}
@supports (-moz-appearance: none) {
  .instrument-row {
    transform: translate3d(0px, 0.2px, 0px);
  }
}
.instrument-row__data-separator {
  padding: 0px !important;
  border-top: 1px dashed #213555;
}
@media (max-width: 720px) {
  .instrument-row__data-separator {
    border-top: 1px dotted rgba(33, 53, 85, 0.5);
  }
}
.instrument-row--first td {
  border-top: none;
}
.instrument-row__instrument-name {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.instrument-row__instrument-name--reverse {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
}
.instrument-row__instrument-name__text__symbol {
  width: 20px;
  margin-left: 0px;
  margin-right: 4px;
  text-align: center;
  text-shadow: -0.5px -0.5px 0 #3E5879, 0.5px -0.5px 0 #3E5879, -0.5px 0.5px 0 #3E5879, 0.5px 0.5px 0 #3E5879;
}
.instrument-row__instrument-spinner {
  height: 32px;
}
.instrument-row__instrument-rate {
  text-align: right;
  gap: 4px;
}
.instrument-row__instrument-rate__currency-symbol {
  width: 28px;
  line-height: 16px;
  overflow: hidden;
}
.instrument-row__instrument-rate-changes {
  text-align: right;
}
@media (max-width: 720px) {
  .instrument-row {
    font-size: 14px !important;
    height: 36px;
    vertical-align: middle;
  }
}`, "",{"version":3,"sources":["webpack://./src/sections/RatesSection/components/ExchangeRatesTableRow.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,mBAAA;AADF;AAGE;EAJF;IAMI,uCAAA;EADF;AACF;AAGE;EACE,uBAAA;EACA,8BAAA;AADJ;AAII;EALF;IAMI,4CAAA;EADJ;AACF;AAKI;EACE,gBAAA;AAHN;AAOE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AALJ;AAOI;EACE,aAAA;EACA,2BAAA;EACA,yBAAA;AALN;AAUM;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EAEA,kBAAA;EAGA,2GACA;AAZR;AAoBE;EACE,YAAA;AAlBJ;AAqBE;EACE,iBAAA;EACA,QAAA;AAnBJ;AAqBI;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;AAnBN;AAuBE;EACE,iBAAA;AArBJ;AAwBE;EA1EF;IA2EI,0BAAA;IACA,YAAA;IACA,sBAAA;EArBF;AACF","sourcesContent":["@use \"../../../utils/themeConstants\";\r\n\r\n.instrument-row {\r\n  font-size: 14px;\r\n  vertical-align: top;\r\n\r\n  @supports (-moz-appearance: none) {\r\n    // workaround for a small graphical bug in library\r\n    transform: translate3d(0px, 0.2px, 0px);\r\n  }\r\n\r\n  &__data-separator {\r\n    padding: 0px !important;\r\n    border-top: 1px dashed themeConstants.$color-dark;\r\n\r\n    // mobile specific border style, because chrome renders 1px dashed border as solid on mobile\r\n    @media(max-width: themeConstants.$mobile-cutoff-width) {\r\n      border-top: 1px dotted rgba(themeConstants.$color-dark, 0.5);\r\n    }\r\n  }\r\n\r\n  &--first {\r\n    td {\r\n      border-top: none;\r\n    }\r\n  }\r\n\r\n  &__instrument-name {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: flex-start;\r\n  \r\n    &--reverse {\r\n      display: flex;\r\n      flex-direction: row-reverse;\r\n      justify-content: flex-end;\r\n    }\r\n  \r\n    &__text {\r\n\r\n      &__symbol {\r\n        width: 20px;\r\n        margin-left: 0px;\r\n        margin-right: 4px;\r\n\r\n        text-align: center;\r\n\r\n        $flag-outline-color: themeConstants.$color-dark-highlight;\r\n        text-shadow: \r\n        -0.5px -0.5px 0 $flag-outline-color,\r\n         0.5px -0.5px 0 $flag-outline-color,\r\n        -0.5px  0.5px 0 $flag-outline-color,\r\n         0.5px  0.5px 0 $flag-outline-color;\r\n      }\r\n    }\r\n  }\r\n\r\n  &__instrument-spinner {\r\n    height: 32px;\r\n  }\r\n\r\n  &__instrument-rate {\r\n    text-align: right;\r\n    gap: 4px;\r\n\r\n    &__currency-symbol {\r\n      width: 28px;\r\n      line-height: 16px;\r\n      overflow: hidden;\r\n    }\r\n  }\r\n  \r\n  &__instrument-rate-changes {\r\n    text-align: right;\r\n  }\r\n\r\n  @media(max-width: themeConstants.$mobile-cutoff-width) {\r\n    font-size: 14px !important;\r\n    height: 36px;\r\n    vertical-align: middle;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
